var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23354 13.9133C7.05354 13.9133 6.88687 13.84 6.76021 13.72L1.86687 8.82664C1.60688 8.56665 1.60688 8.14665 1.86687 7.88665C2.12687 7.62665 2.54688 7.62665 2.80687 7.88665L7.21354 12.2933L14.2002 4.75331C14.4535 4.47998 14.8735 4.46664 15.1402 4.71998C15.4069 4.97331 15.4269 5.39331 15.1735 5.65998L7.71354 13.7066C7.59354 13.84 7.42021 13.92 7.24021 13.92H7.22687L7.23354 13.9133Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.ddf67e4e9bbe05ad4c1844dff3f200b1.svg";
export { ForwardRef as ReactComponent };